export function tenantLabel(tenant, key, fallback) {
  const label = tenant?.settings?.labels?.[key];
  return label && label.trim() ? label.trim() : fallback;
}

export function wipLabel(tenant) {
  return tenantLabel(tenant, "wip", "WIP");
}

export function wipsLabel(tenant) {
  return tenantLabel(tenant, "wips", "WIPs");
}

export function roomLabel(tenant) {
  return tenantLabel(tenant, "room", "Room");
}

export function roomsLabel(tenant) {
  return tenantLabel(tenant, "rooms", "Rooms");
}

export function productionCostYieldReportLabel(tenant) {
  return tenantLabel(
    tenant,
    "production_cost_yield_report",
    "Production Cost & Yield",
  );
}
